/*
  見積もりリスト。Shopify のカート・決済は使わず、ブラウザ (localStorage) に置く。
  在庫0・在庫連動準備中の色サイズも入れられるようにするため (カートは販売できない variant を拒む)。
  送り先は丸昇ホームページと同じ BowNow の見積もりフォーム。「品番と数量」欄を URL で埋めて開く。
*/
(function () {
  var KEY = 'ms_quote_v1';
  var FORMS = {
    sample: { url: 'https://contents.bownow.jp/forms/view/sid_d8cce015145de9fbc03e', field: 'text_area-20230404172001840',
      note: '制作は10枚から承ります。9枚以下はサンプルのご依頼としてお問い合わせフォームへ進みます。', label: 'この内容でサンプルを依頼する' },
    small: { url: 'https://contents.bownow.jp/forms/view/sid_2e701d42bf44f1d22b7e', field: 'text_area-20251029172604725',
      note: '10〜29枚の見積もりフォームへ進みます。', label: 'この内容で見積もりを依頼する' },
    large: { url: 'https://contents.bownow.jp/forms/view/sid_2338a30849a65dde7809', field: 'text_area-20251029172604725',
      note: '30枚以上の見積もりフォームへ進みます。', label: 'この内容で見積もりを依頼する' }
  };
  function formFor(n) { return n >= 30 ? FORMS.large : n >= 10 ? FORMS.small : FORMS.sample; }
  function formKey(f) { return Object.keys(FORMS).filter(function (k) { return FORMS[k] === f; })[0]; }
  // PostHog は marusho-posthog.liquid が入れた時だけある。イベントの一覧は docs/implementation-notes/2026-10-26-mar1644-posthog.md。
  function track(name, props) { if (window.posthog) window.posthog.capture(name, props); }
  // 税込は kintone の標準売価_税込と同じ ROUND(税抜×1.1) = (税抜×11+5)/10。
  function taxIncluded(yen) {
    yen = parseInt(yen, 10) || 0;
    if (yen <= 0) return 0;
    return Math.floor((yen * 11 + 5) / 10);
  }
  function yenLabel(yen) {
    return Number(yen).toLocaleString('ja-JP') + '円（税込' + taxIncluded(yen).toLocaleString('ja-JP') + '円）';
  }
  function moneyTotal(items) {
    if (!items.length || items.some(function (it) { return !(it.y > 0); })) return null;
    return {
      ex: items.reduce(function (n, it) { return n + it.y * it.q; }, 0),
      inc: items.reduce(function (n, it) { return n + taxIncluded(it.y) * it.q; }, 0)
    };
  }
  // 30枚以上フォームの必須欄「作製枚数」(ラジオ)。値はフォームの選択肢そのまま (半角 ~)。
  function sizeBand(n) { return n >= 300 ? '300~枚' : n >= 100 ? '100~299枚' : n >= 80 ? '80~99枚' : n >= 50 ? '50~79枚' : '30~49枚'; }

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function save(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    renderCount(items);
  }
  function total(items) { return items.reduce(function (n, it) { return n + it.q; }, 0); }
  function renderCount(items) {
    var n = total(items || load());
    document.querySelectorAll('[data-ms-quote-count]').forEach(function (el) { el.textContent = n > 0 ? n + '枚' : ''; });
  }

  // 商品ページ: 在庫表の入力欄から追加する。
  function initTable(sec) {
    sec.querySelectorAll('.ms-table td').forEach(function (td) {
      var t = td.firstChild;
      if (t && t.nodeType === 3 && /^\d{4,}$/.test(t.nodeValue.trim())) t.nodeValue = Number(t.nodeValue.trim()).toLocaleString('ja-JP');
    });
    var btn = sec.querySelector('[data-ms-quote-add]');
    var msg = sec.querySelector('[data-ms-quote-msg]');
    if (!btn) return;
    var label = btn.textContent;
    function showSum() {
      var n = 0;
      sec.querySelectorAll('input.ms-q').forEach(function (inp) { var q = parseInt(inp.value, 10); if (q > 0) n += q; });
      btn.textContent = n > 0 ? label + '（合計 ' + n + '枚）' : label;
    }
    // メッセージは画面の下に貼り付いたボタンと一緒に表を覆うので、次の入力か数秒で消す。
    var hideTimer;
    function clearMsg() { clearTimeout(hideTimer); msg.textContent = ''; delete msg.dataset.state; }
    sec.addEventListener('input', function () { clearMsg(); showSum(); });
    window.addEventListener('pageshow', showSum);
    showSum();
    // 商品ページ上で選んだ色を、表の同じ色の行に印を付けて表の枠の中で見える位置へ動かす。色は option1。
    var box = sec.querySelector('.ms-stock__scroll');
    function markColor(scroll) {
      var g = document.querySelector('variant-selects .product-form__input');
      var el = g && (g.querySelector('input:checked') || g.querySelector('select'));
      if (!el) return;
      sec.querySelectorAll('.ms-table tbody tr').forEach(function (tr) {
        var th = tr.querySelector('th');
        var hit = (th.dataset.c || th.textContent.trim()) === el.value;
        tr.toggleAttribute('data-ms-picked', hit);
        if (hit && scroll && box) box.scrollTop = tr.offsetTop - sec.querySelector('.ms-table thead').offsetHeight;
      });
    }
    markColor(false);
    document.addEventListener('change', function (e) { if (e.target.closest('variant-selects')) markColor(true); });
    btn.addEventListener('click', function () {
      var items = load();
      var added = 0;
      var d = sec.dataset;
      var prices = [];
      try { prices = JSON.parse((sec.querySelector('[data-ms-variant-yen]') || {}).textContent || '[]'); } catch (e) {}
      function yenOf(c, s) {
        var hit = prices.find(function (p) { return p.c === c && p.s === s; });
        return hit && hit.y > 0 ? hit.y : 0;
      }
      sec.querySelectorAll('input.ms-q').forEach(function (inp) {
        var q = parseInt(inp.value, 10);
        if (!(q > 0)) return;
        var y = yenOf(inp.dataset.c, inp.dataset.s);
        var hit = items.find(function (it) { return it.h === d.handle && it.c === inp.dataset.c && it.s === inp.dataset.s; });
        if (hit) { hit.q += q; if (y) hit.y = y; if (d.hinban) hit.n = d.hinban; }
        else items.push({ h: d.handle, v: d.vendor, n: d.hinban, t: d.title, c: inp.dataset.c, s: inp.dataset.s, q: q, y: y });
        added += q;
        inp.value = '';
      });
      showSum();
      if (!added) { msg.dataset.state = 'error'; msg.textContent = '見積もりしたい色・サイズの欄に枚数を入力してください。'; return; }
      save(items);
      track('quote_item_added', { qty_added: added, list_qty: total(items), list_items: items.length, handle: d.handle });
      msg.dataset.state = 'ok';
      msg.innerHTML = '<span>' + added + '枚を見積もりリストに追加しました（リストの合計 ' + total(items) + '枚）</span>' +
        '<a class="u-btn u-btn--outline" href="/cart">見積もりリストを見る →</a>';
      clearTimeout(hideTimer);
      hideTimer = setTimeout(clearMsg, 6000);
    });
  }

  // 商品×色ごとにまとめる。l.i は items の添字 (/cart の変更・削除で使う)。
  function groups(items) {
    var out = [];
    items.forEach(function (it, i) {
      var g = out.find(function (x) { return x.h === it.h && x.c === it.c; });
      if (!g) { g = { h: it.h, v: it.v, n: it.n, t: it.t, c: it.c, lines: [] }; out.push(g); }
      g.lines.push({ s: it.s, q: it.q, i: i, y: it.y || 0 });
    });
    return out;
  }
  // 依頼本文。商品ごとに見出し、色ごとに1行、商品の間は空行。単価・金額は入れない (2026-10-06 要望)。
  // ■United Athle 5001-01
  // 　5.6オンス ハイクオリティー Tシャツ
  // 　ホワイト：S-10枚 / M-10枚（計20枚）
  function bodyText(items) {
    var products = [];
    groups(items).forEach(function (g) {
      var p = products.find(function (x) { return x.h === g.h; });
      if (!p) { p = { h: g.h, v: g.v, n: g.n || g.h.toUpperCase(), t: g.t, colors: [] }; products.push(p); }
      p.colors.push(g);
    });
    return products.map(function (p) {
      return ['■' + [p.v, p.n].filter(Boolean).join(' '), '　' + p.t].concat(p.colors.map(function (g) {
        var sum = g.lines.reduce(function (n, l) { return n + l.q; }, 0);
        return '　' + g.c + '：' + g.lines.map(function (l) {
          return l.s + '-' + l.q + '枚';
        }).join(' / ') + '（計' + sum + '枚）';
      })).join('\n');
    }).join('\n\n') + '\n\n合計：' + total(items) + '枚（' + products.length + 'アイテム）';
  }
  // BowNow の訪問者ID。フォーム URL の sid の後ろに付く (埋め込みでは BowNow が cookie で持つ番号)。
  // 固定値だと全員が同じ訪問者として記録されるので、ブラウザごとに1つ作って使い回す。
  function visitorId() {
    try {
      var id = localStorage.getItem('ms_bownow_cid');
      if (!id && window.crypto && crypto.randomUUID) { id = crypto.randomUUID(); localStorage.setItem('ms_bownow_cid', id); }
      return id ? '/' + id : '';
    } catch (e) { return ''; }
  }
  function formUrl(items) {
    var n = total(items);
    var f = formFor(n);
    var text = bodyText(items);
    if (f === FORMS.sample) text = '【サンプル依頼】\n\n' + text;
    return f.url + visitorId() + '?' + f.field + '=' + encodeURIComponent(text) +
      (f === FORMS.large ? '&tracking_tags-20260408105327911=' + encodeURIComponent(sizeBand(n)) : '') +
      // BowNow は外部サイトからの Referer (ヘッダー・referer パラメータとも) で 404 を返す。
      // パラメータは title だけ付け、リンクは rel=noreferrer で開く。
      '&title=' + encodeURIComponent('丸昇カタログ 見積もりリスト');
  }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }

  // /cart: 見積もりリストのページ。
  function renderPage(root) {
    var items = load();
    if (!items.length) {
      root.innerHTML = '<p class="ms-quote__empty">見積もりリストは空です。商品ページの「在庫一覧」で枚数を入力して追加してください。</p>' +
        '<a class="u-btn" href="/collections/all">商品一覧へ</a>';
      return;
    }
    var n = total(items);
    var f = formFor(n);
    var html = groups(items).map(function (g) {
      return '<div class="ms-quote__group"><p class="ms-quote__name"><a href="/products/' + esc(g.h) + '">' +
        esc([g.v, g.n, g.t].filter(Boolean).join(' ')) + '</a><br>' + esc(g.c) + '</p><ul>' +
        g.lines.map(function (l) {
          return '<li><span>' + esc(l.s) + '</span><input type="number" min="0" inputmode="numeric" value="' + l.q +
            '" data-i="' + l.i + '" aria-label="' + esc(g.c + ' ' + l.s) + ' 枚数">枚' +
            (l.y ? '<span class="ms-quote__yen">' + esc(yenLabel(l.y)) + '</span>' : '') +
            '<button type="button" class="ms-quote__del" data-del="' + l.i + '">削除</button></li>';
        }).join('') + '</ul></div>';
    }).join('');
    var money = moneyTotal(items);
    root.innerHTML = html +
      '<p class="ms-quote__total">合計 <strong>' + n + '枚</strong>' +
      (money ? '　税抜' + money.ex.toLocaleString('ja-JP') + '円（税込' + money.inc.toLocaleString('ja-JP') + '円）' : '') +
      '</p>' +
      '<p class="ms-quote__note">' + f.note + '開いたフォームの中ほどにある「品番と数量」の欄に、このリストが入っています。会社名・連絡先・プリント内容などを書き足して送信してください。</p>' +
      '<a class="u-btn ms-quote__go" href="' + esc(formUrl(items)) + '" target="_blank" rel="noopener noreferrer">' +
      f.label + ' ↗</a>' +
      '<button type="button" class="ms-quote__clear" data-clear>リストを空にする</button>';
    // href に依頼本文が入っているので、PostHog の autocapture にはこのリンクを送らせない。
    var go = root.querySelector('.ms-quote__go');
    go.classList.add('ph-no-capture');
    go.addEventListener('click', function () {
      track('quote_request_clicked', { form: formKey(f), list_qty: n, list_items: items.length });
    });
    root.querySelectorAll('input[data-i]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var items = load(); var q = parseInt(inp.value, 10);
        if (q > 0) items[+inp.dataset.i].q = q; else items.splice(+inp.dataset.i, 1);
        save(items); renderPage(root);
      });
    });
    root.querySelectorAll('[data-del]').forEach(function (b) {
      b.addEventListener('click', function () { var items = load(); items.splice(+b.dataset.del, 1); save(items); renderPage(root); });
    });
    root.querySelector('[data-clear]').addEventListener('click', function () {
      if (confirm('見積もりリストを空にしますか？')) { save([]); renderPage(root); }
    });
  }

  function init() {
    renderCount();
    document.querySelectorAll('[data-ms-quote-table]').forEach(initTable);
    var page = document.getElementById('ms-quote-page');
    if (page) renderPage(page);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
